import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { Row, Col } from 'react-flexbox-grid';
import {
  returnOverpayActions,
} from '../ducks';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import rules from '../../../common/rules/rules';
import message from 'antd/lib/message';

const { Item } = Form;


@translate()
@Form.create()
export default class ReturnOverpayModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
  };

  

  handleSubmit = () => {
    const { actions, form, t } = this.props;
    
    form.validateFields((err, values) => {
      if (!err) {
        this.props.returnOverpay( values )
      }
    });
    
    this.props.handleModalCancel()
  }

  

  render() {
    const { visible, amount, t, form, handleModalCancel, iban } = this.props;

    const { getFieldDecorator } = form;


    return <Modal
    visible={visible}
    title={
      t('Vrátenie preplatku')
    }
    onCancel={handleModalCancel}
    handleModalCancel={handleModalCancel}
    footer={[
        <Button type="primary" onClick={this.handleSubmit}>
          {t('Potvrdiť')}
        </Button> ,
        <Button key="cancel" onClick={handleModalCancel}>
          {t('Zavrieť')}
        </Button> 
    ]}
    >
    <div>
      <Form>
        <Item label={t('Suma na vrátenie')} >
          {getFieldDecorator('amount', { rules: [...rules.required, rules.positiveNumber, rules.lessThanValue(Number(this.props.amount))], initialValue: amount })(
            <Input size="default" defaultValue={amount} />
          )}
        </Item>
        <Item label={t('IBAN klienta')} >
          {getFieldDecorator('iban', { initialValue: iban, rules: rules.required })(
            <Input size="default"  value={iban} />
          )}
        </Item>
      </Form>
    </div>
    </Modal>
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/ReturnOverpayModal.js